import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Approval from '../Pages/Approval'
import Dashboard from '../Pages/Dashboard'
import InspectStoreCreditNote from '../Pages/InspectScn'
import InventoryAccount from '../Pages/InventoryAccount'
import LoginPage from '../Pages/LoginPage'
import ManageShelf from '../Pages/ManageShelf'
import ManageStore from '../Pages/ManageStore'
import PickUp from '../Pages/PickUp'
import PickUpGroup from '../Pages/PickUpGroup'
import QualityInspection from '../Pages/QualityInspection'
import Report from '../Pages/Report'
import ReturnToStore from '../Pages/ReturnToStore'
import StoreReceivedAdvise from '../Pages/StoreReceivedAdvise'
import TechApproval from '../Pages/TechApproval'
import TrackProductStatus from '../Pages/TrackProductStatus'
import Transfer from '../Pages/Transfer'
import AccountRoutes from './AccountRoutes'
import IQARoutes from './IQARoutes'
import PrivateRoutes from './PrivateRoute'
import StoreRoutes from './StoreRoutes'
import SupervisorRoutes from './SupervisorRoutes'
import TechSupervisorRoutes from './TechSupervisor'
import TechStoreRoutes from './TechStoreRoutes'
import ExpectedSCN from '../Pages/ExpectedSCN'
import TakeStock from '../Pages/TakeStock'
import PendingFinancialStock from '../Pages/PendingFinancialStock'
import TeamLeadInventory from '../Pages/TeamLeadInventory'
import TeamLeadRoutes from './TeamLeadRoutes'
import StoreSupervisorRoutes from './StoreSupervisorRoutes'
import UserManagement from '../Pages/UserManagement'
import TrackApprovedInventory from '../Pages/TrackApprovedinventory'
import ReadBinShelf from '../Pages/ReadBinShelf'
import DeviceAssignmentRequest from '../Pages/DeviceAssignmentRequest'
import DeviceAssignmentProcurement from '../Pages/DeviceAssignmentProcurement'
import DeviceAssignmentRTS from '../Pages/DeviceAssignmentRTS'
import AdminStore from './AdminStore'

export default function IndexRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<LoginPage />} />

        <Route element={<PrivateRoutes />}>





          <Route element={<StoreSupervisorRoutes />}>
            <Route path='/stock-approval' element={<PendingFinancialStock />} />
          </Route>


          <Route element={<TechStoreRoutes />}>
            <Route path='/expected-return-to-store' element={<ExpectedSCN />} />

          </Route>

          <Route element={<TeamLeadRoutes />}>
            <Route path='/team-lead-inventory' element={<TeamLeadInventory />} />


          </Route>
          <Route element={<AdminStore />}>
            <Route path='/device-assignment-procurement' element={<DeviceAssignmentProcurement />} />
            <Route path='/device-assignment-request' element={<DeviceAssignmentRequest />} />
            <Route path='/device-assignment-rts' element={<DeviceAssignmentRTS />} />

           
          </Route>

          <Route element={<StoreRoutes />}>

            <Route path='/manage-store' element={<ManageStore />} />

            <Route path='/manage-shelf' element={<ManageShelf />} />
            <Route path='/transfer' element={<Transfer />} />
            <Route path='/pick-up' element={<PickUp />} />
            <Route path='/pick-up-group' element={<PickUpGroup />} />
            <Route path='/store-received-advise' element={<StoreReceivedAdvise />} />
            <Route path='/return-to-store' element={<ReturnToStore />} />
          </Route>

          <Route element={<IQARoutes />}>
            <Route path='/quality-inspection' element={<QualityInspection />} />
            <Route path='/inspect-SCN' element={<InspectStoreCreditNote />} />
          </Route>

          <Route element={<AccountRoutes />}>
            <Route path='/take-stock' element={<TakeStock />} />
            <Route path='/inventory-account' element={<InventoryAccount />} />

          </Route>

          <Route element={<SupervisorRoutes />}>
            <Route path='/approval' element={<Approval />} />
          </Route>
          <Route element={<TechSupervisorRoutes />}>
            <Route path='/technical-approval' element={<TechApproval />} />
          </Route>
{/* 
          <Route path='/device-assignment-request' element={<DeviceAssignmentRequest />} />
          <Route path='/device-assignment-rts' element={<DeviceAssignmentRTS />} />
          <Route path='/device-assignment-procurement' element={<DeviceAssignmentProcurement />} /> */}


          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/report' element={<Report />} />
          <Route path='/track-SRA-status' element={<TrackProductStatus />} />
          <Route path='/bin-card' element={<ReadBinShelf />} />
          <Route path='/track-approved-inventory' element={<TrackApprovedInventory />} />
          <Route path='/user-management' element={<UserManagement />} />

        </Route>

      </Routes>
    </BrowserRouter>
  )
}
